import { useEffect, useState, useContext } from 'react';

import { SnackbarContext, SnackbarVariant } from '@eas/common-web';

import { fetchPickupPlaces } from '../new-card-api';
import { Backend } from '../../../../api/endpoints';
import { useIntl } from 'react-intl';

export function usePickupPlaces() {
  const [loading, setLoading] = useState(true);
  const [places, setPlaces] = useState<Backend.Workplace[]>([]);
  const { showSnackbar } = useContext(SnackbarContext);
  const intl = useIntl();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const places = await fetchPickupPlaces();
        setPlaces(places);
      } catch (err) {
        showSnackbar(
          intl.formatMessage({
            id: 'VPUK__NEW_CARD__ORDER__FIND_PLACES_FAILED',
          }),
          SnackbarVariant.ERROR
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [intl, showSnackbar]);

  return { places, loading };
}
